import { axios } from '@/plugins/axios'
import { User } from '@/models/User'
import { Note } from '@/models/Note'
import store from '@/store';
import { BackendGameFull } from '@/models/BackendGameFull';
const base = 'http://localhost:8000/api/'


export default ({
  loadSessions() {
    return axios.get('sessions', getHeaders())
  },
  loadProbablyGames() {
    return axios.get('probable_rg_games_for_today', getHeaders())
  },
  loadGamesForSession(sessionId: number) {
    return axios.get(`session/${sessionId}/games`, getHeaders())
  },
  checkCreateFinalTableForSession(sessionId: number) {
    return axios.get(`session/${sessionId}/check_create_final_table/`, getHeaders())
  },
  createFinalTableForSession(sessionId: number) {
    return axios.post(`session/${sessionId}/create_final_table/`, {}, getHeaders())
  },
  createSession(rgGameIds: number[], awGameIds: (number | null)[], isHidden: boolean) {
    return axios.post('create_session/', { rg_games: rgGameIds, aw_game_ids: awGameIds, is_hidden: isHidden }, getHeaders())
  },
  saveGame(game: BackendGameFull) {
    return axios.put(`games/${game.id}/`, game, getHeaders())
  },
  loadGame(gameId: number) {
    return axios.get(`games/${gameId}`, getHeaders())
  },
  loadPlayerStats(playerId: number) {
    return axios.get(`player_stats/${playerId}`, getHeaders())
  },
  loadTeams() {
    return axios.get(`general/teams/`, getHeaders())
  },
  loadOORHeaders() {
    return axios.get(`oor/markup_headers/`, getHeaders())
  },
  loadOORMarkup(teamId: number, season: number) {
    return axios.get(`oor/markup/?team_id=${teamId}&season=${season}`, getHeaders())
  },
  loadSeasonRoster(teamId: number, season: number) {
    return axios.get(`general/roster/?team_id=${teamId}&season=${season}`, getHeaders())
  },
  saveOORMarkup(objectsToSave: any[]) {
    return axios.put('oor/markup/', objectsToSave, getHeaders())
  },
  updateRoster(objectsToSave: any[]) {
    return axios.put('general/roster/', objectsToSave, getHeaders())
  },
  loadSeasons() {
    return axios.get(`general/seasons/`, getHeaders())
  },
  loadGames() {
    return axios.get(`general/games/`, getHeaders())
  },
  loadStatuses() {
    return axios.get('general/statuses/', getHeaders())
  },
  loadPlayers() {
    return axios.get('general/players/', getHeaders())
  },
  newRoster(payload: any) {
    return axios.post('general/roster/', payload, getHeaders())
  },
  getNotesForPlayer(playerId: number, weekId?: number) {
    let query = `?player_id=${playerId}`
    if (weekId) {
      query = `${query}&week_id=${weekId}`
    }
    return axios.get(`notes/${query}`, getHeaders())
  },
  updateNote(note: Note) {
    return axios.put(`notes/${note.id}`, note, getHeaders())
  },
  createNote(playerId: number, weekId: number, text: string) {
    return axios.post('notes/', { player_id: playerId, week_id: weekId, text: text }, getHeaders())
  }
})

export async function reset(user: User) {
  return (
    await axios.post(
      `${base}/users/reset`,
      {},
      {
        headers: getHeaders(),
      }
    )
  ).data
}

function getHeaders() {
  let headers = { headers: { Authorization: 'Bearer ' + (store as any).state.AppStore.token } }
  return headers;
}
